import "./index.css";

export function LoadingLine() {
    return (
        <div className="h-screen w-screen flex items-center justify-center">
            <div className="loader-line"></div>
        </div>
    )
} 